import {
  FaUserTie,
  FaBriefcase,
  FaGlobe,
  FaUsers,
  FaMagnifyingGlass,
  FaHandshake,
  FaAward,
  FaUserGroup,
  FaHeart,
  FaTruckFast,
  FaGem,
  FaLightbulb,
  FaRegClock,
  FaUserCheck,
  FaBuildingColumns,
  FaLayerGroup,
  FaLaptopCode,
  FaBuildingUser,
  FaStethoscope,
  FaLandmark,
  FaHandshakeSimple,
  FaCoins,
  FaIndustry,
  FaStore,
  FaHotel,
  FaTruckRampBox,
  FaSignal,
  FaCartShopping,
  FaHeadset,
  FaRocket,
  FaBolt,
  FaShieldHalved,
  FaCheck,
  FaStar,
  FaQuoteLeft,
} from "react-icons/fa6";

const MAP = {
  FaUserTie,
  FaBriefcase,
  FaGlobe,
  FaUsers,
  FaMagnifyingGlass,
  FaHandshake,
  FaAward,
  FaUserGroup,
  FaHeart,
  FaTruckFast,
  FaGem,
  FaLightbulb,
  FaRegClock,
  FaUserCheck,
  FaBuildingColumns,
  FaLayerGroup,
  FaLaptopCode,
  FaBuildingUser,
  FaStethoscope,
  FaLandmark,
  FaHandshakeSimple,
  FaCoins,
  FaIndustry,
  FaStore,
  FaHotel,
  FaTruckRampBox,
  FaSignal,
  FaCartShopping,
  FaHeadset,
  FaRocket,
  FaBolt,
  FaShieldHalved,
  FaCheck,
  FaStar,
  FaQuoteLeft,
};

export const Icon = ({ name, className }) => {
  const Cmp = MAP[name];
  if (!Cmp) return <FaUserCheck className={className} />;
  return <Cmp className={className} />;
};

export default Icon;
